<template>
  <div class="about">
    <h1>A little reminder for a head in the clouds</h1>
  </div>
</template>
